(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-carousel')) {
    class HeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.dotsContainer = this.querySelector('[data-carousel-dots]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.currentNumber = this.querySelector('[data-carousel-current]');
        this.progressBar = this.querySelector('[data-carousel-progress]');
        this.currentIndex = 0;
        this.timer = null;
        this.progressAnimation = null;
        this.transitionTimer = null;
        this.pointerStartX = null;
        this.pointerCurrentX = null;
        this.pointerDownTime = 0;
        this.isDragging = false;
        this.suppressClick = false;
        this.gestureTimer = null;
        this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onViewportChange = () => this.updateContainerRatio(this.slides[this.currentIndex]);
        this.mobileQuery.addEventListener?.('change', this.onViewportChange);

        this.buildDots();
        this.previousButton?.addEventListener('click', () => this.go(-1, true));
        this.nextButton?.addEventListener('click', () => this.go(1, true));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => {
          this.style.setProperty('--carousel-x', '0px');
          this.style.setProperty('--carousel-y', '0px');
          if (!this.isDragging && !this.classList.contains('is-settling')) this.start();
        });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('pointermove', (event) => this.onPointerMove(event));
        this.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.addEventListener('pointercancel', (event) => this.onPointerUp(event));
        this.addEventListener('click', (event) => this.onCarouselClick(event), true);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(-1, true);
          if (event.key === 'ArrowRight') this.go(1, true);
        });

        this.onVisibilityChange = () => document.hidden ? this.stop() : this.start();
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.show(0, false, 'next');
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.clearTimeout(this.transitionTimer);
        window.clearTimeout(this.gestureTimer);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileQuery?.removeEventListener?.('change', this.onViewportChange);
      }

      buildDots() {
        if (!this.dotsContainer) {
          this.dots = [];
          return;
        }

        this.dotsContainer.replaceChildren();
        this.dots = this.slides.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `hero__carousel-dot${index === 0 ? ' is-active' : ''}`;
          dot.dataset.carouselDot = String(index);
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.setAttribute('aria-current', String(index === 0));
          dot.addEventListener('click', () => {
            const direction = index >= this.currentIndex ? 'next' : 'previous';
            this.show(index, true, direction);
          });
          this.dotsContainer.appendChild(dot);
          return dot;
        });
      }

      show(index, userInitiated = false, direction = 'next') {
        if (!this.slides.length) return;
        const targetIndex = (index + this.slides.length) % this.slides.length;
        const previousSlide = this.slides[this.currentIndex];
        const targetSlide = this.slides[targetIndex];
        this.dataset.direction = direction;

        window.clearTimeout(this.transitionTimer);
        this.slides.forEach((slide) => slide.classList.remove('is-leaving'));
        if (previousSlide && previousSlide !== targetSlide) previousSlide.classList.add('is-leaving');
        this.currentIndex = targetIndex;
        this.updateContainerRatio(targetSlide);

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('video').forEach((video) => {
            if (active) video.play().catch(() => {});
            else video.pause();
          });
        });

        this.transitionTimer = window.setTimeout(() => {
          this.slides.forEach((slide) => slide.classList.remove('is-leaving'));
        }, 900);

        this.dots.forEach((dot) => {
          const active = Number(dot.dataset.carouselDot) === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        if (this.currentNumber) this.currentNumber.textContent = String(this.currentIndex + 1).padStart(2, '0');
        this.restartProgress();

        if (userInitiated) {
          this.stop();
          this.start();
        }
      }

      updateContainerRatio(slide) {
        const hero = this.closest('.hero');
        if (!hero || !slide) return;

        if (!this.mobileQuery?.matches) {
          hero.style.removeProperty('--hero-current-aspect-ratio');
          return;
        }

        const rawRatio = slide.dataset.mobileAspectRatio || slide.dataset.aspectRatio;
        const ratio = Number.parseFloat(rawRatio);
        if (Number.isFinite(ratio) && ratio > 0) {
          hero.style.setProperty('--hero-current-aspect-ratio', String(ratio));
        }
      }

      go(direction, userInitiated = false) {
        if (this.slides.length < 2) return;
        const nextIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length;
        this.show(nextIndex, userInitiated, direction > 0 ? 'next' : 'previous');
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.target.closest('button') || this.slides.length < 2) return;
        this.pointerStartX = event.clientX;
        this.pointerCurrentX = event.clientX;
        this.pointerDownTime = performance.now();
        this.isDragging = true;
        this.suppressClick = false;
        this.classList.add('is-dragging', 'is-gesture');
        this.updateSlidePositions(0);
        this.style.setProperty('--drag-offset', '0px');
        this.stop();
        this.setPointerCapture?.(event.pointerId);
      }

      onPointerMove(event) {
        const rect = this.getBoundingClientRect();
        const localX = event.clientX - rect.left;
        const localY = event.clientY - rect.top;
        this.style.setProperty('--cursor-x', `${localX}px`);
        this.style.setProperty('--cursor-y', `${localY}px`);

        if (this.dataset.parallax === 'true' && !this.reduceMotionQuery.matches) {
          const parallaxX = ((localX / rect.width) - .5) * -6;
          const parallaxY = ((localY / rect.height) - .5) * -4;
          this.style.setProperty('--carousel-x', `${parallaxX}px`);
          this.style.setProperty('--carousel-y', `${parallaxY}px`);
        }

        if (!this.isDragging || this.pointerStartX === null) return;
        this.pointerCurrentX = event.clientX;
        const maxDistance = rect.width * .92;
        const distance = Math.max(Math.min(event.clientX - this.pointerStartX, maxDistance), -maxDistance);
        if (Math.abs(distance) > 6) this.suppressClick = true;
        this.updateSlidePositions(distance);
        this.style.setProperty('--drag-offset', `${distance}px`);
      }

      onPointerUp(event) {
        if (!this.isDragging || this.pointerStartX === null) return;
        const endX = this.pointerCurrentX ?? event.clientX;
        const distance = endX - this.pointerStartX;
        const elapsed = Math.max(performance.now() - this.pointerDownTime, 1);
        const velocity = Math.abs(distance) / elapsed;
        const width = this.getBoundingClientRect().width;
        const threshold = Math.min(Math.max(width * .14, 52), 120);
        const shouldAdvance = Math.abs(distance) >= threshold || (Math.abs(distance) > 24 && velocity > .45);
        const direction = distance < 0 ? 1 : -1;
        const directionName = direction > 0 ? 'next' : 'previous';

        this.isDragging = false;
        this.pointerStartX = null;
        this.pointerCurrentX = null;
        this.classList.remove('is-dragging');
        this.classList.add('is-settling');
        void this.offsetWidth;

        if (shouldAdvance && this.slides.length > 1) {
          const targetIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length;
          this.show(targetIndex, false, directionName);
        }

        this.style.setProperty('--drag-offset', '0px');
        this.updateSlidePositions(shouldAdvance ? -distance : distance);

        window.clearTimeout(this.gestureTimer);
        this.gestureTimer = window.setTimeout(() => {
          this.classList.remove('is-gesture', 'is-settling');
          this.slides.forEach((slide) => slide.style.removeProperty('--slide-x'));
          this.start();
        }, 650);

        if (this.suppressClick) {
          window.setTimeout(() => { this.suppressClick = false; }, 80);
        }
      }

      updateSlidePositions(dragDistance = 0) {
        const count = this.slides.length;
        if (!count) return;

        this.slides.forEach((slide, index) => {
          let position = index - this.currentIndex;
          if (position > count / 2) position -= count;
          if (position < -count / 2) position += count;
          if (count === 2 && index !== this.currentIndex) position = dragDistance > 0 ? -1 : 1;
          slide.style.setProperty('--slide-x', `${position * 100}%`);
        });
      }

      onCarouselClick(event) {
        if (event.target.closest('button')) return;
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (event.target.closest('[data-slide-link]')) return;
        const fallbackLink = this.dataset.fallbackLink;
        if (!fallbackLink) return;
        if (this.dataset.fallbackNewTab === 'true') window.open(fallbackLink, '_blank', 'noopener');
        else window.location.href = fallbackLink;
      }

      restartProgress() {
        this.progressAnimation?.cancel();
        if (!this.progressBar || this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.reduceMotionQuery.matches) return;
        const interval = Math.max(Number(this.dataset.interval) || 5000, 2000);
        this.progressAnimation = this.progressBar.animate(
          [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration: interval, easing: 'linear', fill: 'forwards' }
        );
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.reduceMotionQuery.matches || this.slides.length < 2) return;
        const interval = Math.max(Number(this.dataset.interval) || 5000, 2000);
        this.timer = window.setInterval(() => this.go(1), interval);
        this.restartProgress();
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
        this.progressAnimation?.cancel();
        this.progressAnimation = null;
      }
    }

    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review-stack"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-card-stack')) {
    class ReviewCardStack extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-stack-card]'));
        this.stage = this.querySelector('[data-stack-stage]');
        this.previousButton = this.querySelector('[data-stack-prev]');
        this.nextButton = this.querySelector('[data-stack-next]');
        this.stagePreviousButton = this.querySelector('[data-stack-stage-prev]');
        this.stageNextButton = this.querySelector('[data-stack-stage-next]');
        this.dotsContainer = this.querySelector('[data-stack-dots]');
        this.productButtons = Array.from(this.querySelectorAll('[data-stack-product]'));
        this.currentLabel = this.querySelector('[data-stack-current]');
        this.progress = this.querySelector('[data-stack-progress]');
        this.section = this.closest('.review-stack');
        this.current = 0;
        this.timer = null;
        this.progressAnimation = null;
        this.dragStartX = null;
        this.dragX = 0;
        this.dragStartedAt = 0;
        this.dragging = false;
        this.suppressClick = false;
        this.suppressTimer = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.cards.length) return;

        this.buildDots();
        this.render(false);

        this.previousButton?.addEventListener('click', () => this.go(-1, true));
        this.nextButton?.addEventListener('click', () => this.go(1, true));
        this.stagePreviousButton?.addEventListener('click', () => this.go(-1, true));
        this.stageNextButton?.addEventListener('click', () => this.go(1, true));
        this.productButtons.forEach((button) => {
          button.addEventListener('click', () => this.show(Number(button.dataset.stackProduct), true));
        });
        this.addEventListener('keydown', (event) => this.onKeydown(event));
        this.stage?.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.stage?.addEventListener('pointermove', (event) => this.onPointerMove(event));
        this.stage?.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.stage?.addEventListener('pointercancel', (event) => this.onPointerUp(event));
        this.stage?.addEventListener('pointerleave', (event) => this.onPointerLeave(event));
        this.addEventListener('click', (event) => this.onClickCapture(event), true);

        this.onVisibility = () => document.hidden ? this.stop() : this.start();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.onBlockSelect = (event) => {
          const card = event.target.closest?.('[data-stack-card]');
          if (!card || !this.contains(card)) return;
          this.show(Number(card.dataset.index), false);
          this.stop();
        };
        this.onBlockDeselect = () => this.start();
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => {
            if (!this.dragging) this.start();
          });
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
        }

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.suppressTimer) window.clearTimeout(this.suppressTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      buildDots() {
        if (!this.dotsContainer) return;
        this.dotsContainer.replaceChildren();
        this.dots = this.cards.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'review-stack__dot';
          dot.setAttribute('aria-label', `Go to review ${index + 1}`);
          dot.addEventListener('click', () => this.show(index, true));
          this.dotsContainer.appendChild(dot);
          return dot;
        });
      }

      render(animate = true) {
        const total = this.cards.length;
        const depth = Number.parseFloat(getComputedStyle(this.section).getPropertyValue('--review-stack-intensity')) || 1;

        this.cards.forEach((card, index) => {
          let offset = (index - this.current + total) % total;
          if (offset > total / 2) offset -= total;
          const distance = Math.abs(offset);
          const direction = Math.sign(offset);
          const visible = distance <= 2;
          const x = visible ? direction * distance * 44 * depth : direction * 120;
          const y = visible ? distance * 18 * depth : 48;
          const z = visible ? -distance * 80 * depth : -240;
          const rotation = visible ? direction * distance * 2.4 * depth : direction * 5;
          const scale = visible ? 1 - distance * .055 * depth : .82;
          const opacity = visible ? Math.max(.12, 1 - distance * .28) : 0;

          card.style.setProperty('--card-x', `${x}px`);
          card.style.setProperty('--card-y', `${y}px`);
          card.style.setProperty('--card-z', `${z}px`);
          card.style.setProperty('--card-r', `${rotation}deg`);
          card.style.setProperty('--card-scale', String(scale));
          card.style.setProperty('--card-opacity', String(opacity));
          card.style.zIndex = String(20 - distance);
          card.classList.toggle('is-active', offset === 0);
          card.setAttribute('aria-hidden', String(offset !== 0));
          card.style.pointerEvents = offset === 0 ? 'auto' : 'none';
          card.querySelectorAll('a, button').forEach((control) => {
            control.tabIndex = offset === 0 ? 0 : -1;
          });
        });

        this.dots?.forEach((dot, index) => {
          const active = index === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        this.productButtons.forEach((button, index) => {
          const active = index === this.current;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });

        if (this.currentLabel) this.currentLabel.textContent = String(this.current + 1).padStart(2, '0');
        if (animate) this.restartProgress();
      }

      show(index, userInitiated = false) {
        this.current = (index + this.cards.length) % this.cards.length;
        this.classList.add('has-interacted');
        this.resetDrag();
        this.render(true);
        if (userInitiated) {
          this.productButtons[this.current]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          this.stop();
          this.start();
        }
      }

      go(direction, userInitiated = false) {
        if (this.cards.length < 2) return;
        this.show(this.current + direction, userInitiated);
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(-1, true);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(1, true);
        }
      }

      onPointerDown(event) {
        if (this.cards.length < 2 || event.button !== 0) return;
        if (event.target.closest('a, button')) {
          this.suppressClick = false;
          if (this.suppressTimer) window.clearTimeout(this.suppressTimer);
          return;
        }
        this.dragStartX = event.clientX;
        this.dragX = 0;
        this.dragStartedAt = performance.now();
        this.dragging = true;
        this.suppressClick = false;
        this.classList.add('is-dragging', 'has-interacted');
        this.stop();
        this.stage.setPointerCapture?.(event.pointerId);
      }

      onPointerMove(event) {
        if (this.dragging && this.dragStartX !== null) {
          this.dragX = event.clientX - this.dragStartX;
          const limit = Math.min(180, this.stage.clientWidth * .42);
          const resisted = Math.sign(this.dragX) * Math.min(Math.abs(this.dragX), limit);
          this.style.setProperty('--stack-drag-x', `${resisted}px`);
          this.style.setProperty('--stack-drag-rotate', `${resisted * .045}deg`);
          this.style.setProperty('--stack-tilt-y', `${resisted * .018}deg`);
          this.suppressClick = Math.abs(this.dragX) > 7;
          return;
        }

        if (event.pointerType !== 'mouse' || !this.stage) return;
        const bounds = this.stage.getBoundingClientRect();
        const px = (event.clientX - bounds.left) / bounds.width;
        const py = (event.clientY - bounds.top) / bounds.height;
        this.style.setProperty('--stack-tilt-y', `${(px - .5) * 5}deg`);
        this.style.setProperty('--stack-tilt-x', `${(.5 - py) * 4}deg`);
        this.section?.style.setProperty('--stack-x', `${px * 100}%`);
        this.section?.style.setProperty('--stack-y', `${py * 100}%`);
      }

      onPointerUp(event) {
        if (!this.dragging) return;
        const elapsed = Math.max(1, performance.now() - this.dragStartedAt);
        const velocity = this.dragX / elapsed;
        const threshold = Math.min(82, this.stage.clientWidth * .16);
        const shouldMove = Math.abs(this.dragX) > threshold || Math.abs(velocity) > .55;
        // Requested gesture map: swipe right = next product, swipe left = previous product.
        const direction = this.dragX > 0 ? 1 : -1;

        this.dragging = false;
        this.classList.remove('is-dragging');
        this.stage.releasePointerCapture?.(event.pointerId);

        const shouldSuppress = this.suppressClick;
        if (shouldMove) this.go(direction, true);
        else {
          this.resetDrag();
          this.start();
        }
        if (shouldSuppress) {
          this.suppressClick = true;
          if (this.suppressTimer) window.clearTimeout(this.suppressTimer);
          this.suppressTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 320);
        }
      }

      onPointerLeave(event) {
        if (!this.dragging) {
          this.style.setProperty('--stack-tilt-x', '0deg');
          this.style.setProperty('--stack-tilt-y', '0deg');
          return;
        }
        if (event.buttons === 0) this.onPointerUp(event);
      }

      onClickCapture(event) {
        if (event.target.closest('a, button, input, select, textarea')) {
          this.suppressClick = false;
          return;
        }
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }
        if (event.defaultPrevented) return;
        const card = event.target.closest('[data-stack-card].is-active');
        const url = card?.dataset.cardUrl;
        const isEditor = Boolean(window.Shopify && window.Shopify.designMode);
        if (!url || isEditor) return;
        if (card.dataset.cardTarget === '_blank') {
          window.open(url, '_blank', 'noopener');
          return;
        }
        window.location.assign(url);
      }

      resetDrag() {
        this.dragStartX = null;
        this.dragX = 0;
        this.style.setProperty('--stack-drag-x', '0px');
        this.style.setProperty('--stack-drag-rotate', '0deg');
        this.style.setProperty('--stack-tilt-x', '0deg');
        this.style.setProperty('--stack-tilt-y', '0deg');
      }

      restartProgress() {
        this.progressAnimation?.cancel();
        if (!this.progress || this.dataset.autoplay !== 'true' || this.reduceMotion.matches) return;
        const duration = Number(this.dataset.interval) || 5000;
        this.progressAnimation = this.progress.animate(
          [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration, easing: 'linear', fill: 'forwards' }
        );
      }

      start() {
        this.stop();
        if (this.cards.length < 2 || this.dataset.autoplay !== 'true' || this.reduceMotion.matches || document.hidden) return;
        const interval = Number(this.dataset.interval) || 5000;
        this.restartProgress();
        this.timer = window.setInterval(() => this.go(1, false), interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
        this.progressAnimation?.cancel();
      }
    }

    customElements.define('review-card-stack', ReviewCardStack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorliva-cinematic-overlay"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-vorliva-opening]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const storageKey = 'vorliva-opening-seen-v13-refined-v2';
    const showOnce = root.dataset.showOnce === 'true';
    const isEditor = Boolean(window.Shopify && window.Shopify.designMode);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const minimumDuration = Number.parseInt(root.dataset.duration, 10) || 2200;
    const maximumWait = Number.parseInt(root.dataset.maxWait, 10) || 5500;
    const readyLabel = root.dataset.readyLabel || '';
    const counter = root.querySelector('[data-vorliva-opening-count]');
    const bar = root.querySelector('[data-vorliva-opening-bar]');
    const status = root.querySelector('[data-vorliva-opening-status]');
    const skip = root.querySelector('[data-vorliva-opening-skip]');
    let finished = false;
    let startTime = performance.now();
    let frame = 0;

    const wait = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));
    const hasSeen = () => {
      if (!showOnce || isEditor) return false;
      try {
        return window.sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    };

    const remember = () => {
      if (!showOnce || isEditor) return;
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        return;
      }
    };

    const signalReady = () => {
      document.documentElement.dataset.vorlivaIntro = 'complete';
      document.dispatchEvent(new CustomEvent('vorliva:intro-complete'));
    };

    const pageReady = () => {
      const loaded = document.readyState === 'complete'
        ? Promise.resolve()
        : new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));
      const fonts = document.fonts?.ready || Promise.resolve();
      return Promise.all([loaded, fonts]);
    };

    const renderProgress = () => {
      const elapsed = performance.now() - startTime;
      const progress = Math.min(elapsed / minimumDuration, 0.92);
      if (bar) bar.style.transform = `scaleX(${progress})`;
      if (counter) counter.textContent = String(Math.round(progress * 100)).padStart(2, '0');
      if (!finished) frame = window.requestAnimationFrame(renderProgress);
    };

    const finish = () => {
      if (finished) return;
      finished = true;
      remember();
      signalReady();
      window.cancelAnimationFrame(frame);
      root.setAttribute('aria-busy', 'false');
      if (status) status.textContent = readyLabel;
      if (bar) bar.style.transform = 'scaleX(1)';
      if (counter) counter.textContent = '100';
      window.setTimeout(() => {
        root.classList.add('is-leaving');
        window.setTimeout(() => root.classList.add('is-revealing'), 520);
        window.setTimeout(() => {
          root.classList.add('is-gone');
          root.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('vorliva-opening-lock');
          window.setTimeout(() => root.remove(), 260);
        }, 1040);
      }, reduceMotion ? 0 : 260);
    };

    if (hasSeen()) {
      signalReady();
      root.remove();
      return;
    }

    document.documentElement.dataset.vorlivaIntro = 'running';
    if (!window.location.hash) window.scrollTo(0, 0);
    document.body.classList.add('vorliva-opening-lock');
    window.requestAnimationFrame(() => {
      root.classList.add('is-running');
      frame = window.requestAnimationFrame(renderProgress);
    });

    Promise.all([wait(minimumDuration), pageReady()]).then(finish);
    window.setTimeout(finish, maximumWait);
    if (skip) skip.addEventListener('click', finish);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') finish();
    }, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorliva-footer-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFooterDirectory = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const revealItems = [...section.querySelectorAll('[data-vfd-reveal]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.classList.add('is-enhanced');
      revealItems.forEach((item, index) => item.style.setProperty('--vfd-delay', `${Math.min(index, 5) * 70}ms`));

      if ('IntersectionObserver' in window && !reduceMotion) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches || reduceMotion) return;
      section.querySelectorAll('[data-vfd-magnetic]').forEach((element) => {
        element.addEventListener('pointermove', (event) => {
          const bounds = element.getBoundingClientRect();
          const x = (event.clientX - bounds.left - bounds.width / 2) * 0.1;
          const y = (event.clientY - bounds.top - bounds.height / 2) * 0.16;
          element.style.setProperty('--vfd-mx', `${x}px`);
          element.style.setProperty('--vfd-my', `${y}px`);
        });
        element.addEventListener('pointerleave', () => {
          element.style.setProperty('--vfd-mx', '0px');
          element.style.setProperty('--vfd-my', '0px');
        });
      });
    };

    document.querySelectorAll('[data-vorliva-footer-directory]').forEach(initializeFooterDirectory);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-vorliva-footer-directory]');
      if (section) initializeFooterDirectory(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorliva-product-assurance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeAssurance = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      const elements = [...section.querySelectorAll('[data-vpa-card], [data-vpa-media], [data-vpa-reveal]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.classList.add('is-enhanced');
      elements.forEach((element, index) => {
        element.style.setProperty('--vpa-delay', `${Math.min(index, 6) * 65}ms`);
      });

      if ('IntersectionObserver' in window && !reduceMotion) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        elements.forEach((element) => observer.observe(element));
      } else {
        elements.forEach((element) => element.classList.add('is-visible'));
      }

      const media = section.querySelector('[data-vpa-media]');
      if (!media || reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      media.addEventListener('pointermove', (event) => {
        const bounds = media.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 12;
        const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 12;
        media.style.setProperty('--vpa-media-x', `${x}px`);
        media.style.setProperty('--vpa-media-y', `${y}px`);
      });
      media.addEventListener('pointerleave', () => {
        media.style.setProperty('--vpa-media-x', '0px');
        media.style.setProperty('--vpa-media-y', '0px');
      });
    };

    document.querySelectorAll('[data-vorliva-product-assurance]').forEach(initializeAssurance);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-vorliva-product-assurance]');
      if (section) initializeAssurance(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorliva-trust-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTrustHub = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cards = [...section.querySelectorAll('[data-vth-card]')];
      const notes = [...section.querySelectorAll('[data-vth-note]')];
      const revealItems = [...cards, ...notes];
      const mobile = window.matchMedia('(max-width: 989px)');
      section.classList.add('is-enhanced');
      notes.forEach((note, index) => note.style.setProperty('--vth-note-delay', `${index * 85}ms`));

      if ('IntersectionObserver' in window && !reduceMotion) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.16 });
        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      const configureAccordion = () => {
        cards.forEach((card, index) => {
          card.open = index === 0;
        });
      };
      configureAccordion();
      mobile.addEventListener('change', configureAccordion);
      cards.forEach((card) => {
        card.addEventListener('toggle', () => {
          if (!card.open) return;
          cards.forEach((otherCard) => {
            if (otherCard !== card) otherCard.open = false;
          });
        });
      });

      const track = section.querySelector('[data-vth-track]');
      const previous = section.querySelector('[data-vth-prev]');
      const next = section.querySelector('[data-vth-next]');
      const move = (direction) => {
        if (!track) return;
        track.scrollBy({ left: track.clientWidth * 0.72 * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      if (previous) previous.addEventListener('click', () => move(-1));
      if (next) next.addEventListener('click', () => move(1));

      const updateControls = () => {
        if (!track) return;
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        section.classList.toggle('has-note-overflow', maxScroll > 2);
        if (previous) previous.disabled = !(track.scrollLeft > 2);
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      };
      if (track) {
        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls);
        window.requestAnimationFrame(updateControls);
      }

      if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      section.querySelectorAll('[data-vth-magnetic]').forEach((button) => {
        button.addEventListener('pointermove', (event) => {
          const bounds = button.getBoundingClientRect();
          const x = (event.clientX - bounds.left - bounds.width / 2) * 0.1;
          const y = (event.clientY - bounds.top - bounds.height / 2) * 0.16;
          button.style.setProperty('--vth-mx', `${x}px`);
          button.style.setProperty('--vth-my', `${y}px`);
        });
        button.addEventListener('pointerleave', () => {
          button.style.setProperty('--vth-mx', '0px');
          button.style.setProperty('--vth-my', '0px');
        });
      });
    };

    document.querySelectorAll('[data-vorliva-trust-hub]').forEach(initializeTrustHub);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-vorliva-trust-hub]');
      if (section) initializeTrustHub(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
